import { inject, Injectable } from '@angular/core';
import { Query } from '@datorama/akita';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import {
  PaymentQuarterData,
  PaymentScheduleState,
  PaymentScheduleStore,
} from './payment-schedule.store';

@Injectable({ providedIn: 'root' })
export class PaymentScheduleQuery extends Query<PaymentScheduleState> {
  protected store: PaymentScheduleStore;

  constructor() {
    const store = inject(PaymentScheduleStore);

    super(store);

    this.store = store;
  }

  getPaymentScheduleCumulative(): Observable<PaymentQuarterData[]> {
    return this.select('PAYMENT_SCHEDULE_CUMULATIVE_PAYMENTS_VS_CUMULATIVE_WP').pipe(
      map(Object.values)
    );
  }
}
